import React, { useContext, useState } from "react";

import UserContext from "../WelcomeUser/UserContext";

import UserDetails from "./UserDetails";
import UserMenu from "./UserMenu";

import UserBookmarks from "./UserBookmarks";
import UserCoupons from "./UserCoupons";
import UserPolls from "./UserPolls";
import UserUpdateProfile from "./UserUpdateProfile";

import "./UserSection.scss";

const logoutText = "¿Seguro de que quieres salir?";

const defaultMenu = [
  {
    section: "bookmarks",
    active: true,
    fontAwesomeIconName: "fas fa-bookmark",
  },
  {
    section: "polls",
    active: false,
    fontAwesomeIconName: "fas fa-poll",
  },
  {
    section: "update-profile",
    active: false,
    fontAwesomeIconName: "fa fa-cog",
  },
  {
    section: "update-coupons",
    active: false,
    fontAwesomeIconName: "fas fa-certificate",
  },
  {
    section: "logout",
    active: false,
    fontAwesomeIconName: "fas fa-sign-out-alt",
  },
];

const UserSection = () => {
  const user = useContext(UserContext);
  const defaultSection = defaultMenu.filter((e) => e.active)[0].section;

  const [menu, setMenu] = useState(defaultMenu);
  const [section, setSection] = useState(defaultSection);

  const handleSection = (section) => {
    if (section === "logout") {
      const userResponse = confirm(logoutText);

      if (userResponse) {
        return (window.location =
          window.location.href.split("?")[0] + "?type=logout");
      }
      return;
    }

    setMenu(
      menu.map((e) =>
        e.section === section ? { ...e, active: true } : { ...e, active: false }
      )
    );
    setSection(section);
  };

  return (
    <div id="user-section">
      <UserDetails user={user} />
      <UserMenu menu={menu} onChangeSection={handleSection} />
      {section === "bookmarks" && <UserBookmarks user={user} />}
      {section === "polls" && <UserPolls user={user} />}
      {section === "update-profile" && <UserUpdateProfile />}
      {section === "update-coupons" && <UserCoupons />}
    </div>
  );
};

export const TitleSection = ({ title }) => (
  <div className="title-section">{title}</div>
);

export const BreakLine = () => <div className="break-line" />;

export default UserSection;
